import Popovers from "material-ui/Popover";

export default Popovers;



// WEBPACK FOOTER //
// ./src/components/uielements/popover.js